import React from 'react'
import SideBar from '../../components/UserDashboard/SideBar'
import EfficiencyHeader from '../../components/Efficiency/EfficiencyHeader'
import ImprovementBaselineHistory from '../../components/Efficiency/ImprovementBaselineHistory'
import { Link } from 'react-router-dom'
function EfficiencyBaselineTables() {
  return (
   <>
    <div className='flex'>
<div>
    <SideBar/>

</div>
<div>

    <div > 
      <Link className='ml-10 mt-32 flex' to={"/efficiency-home"}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.0004 10.9987H7.83041L12.7104 6.11869C13.1004 5.72869 13.1004 5.08869 12.7104 4.69869C12.6179 4.60599 12.508 4.53244 12.387 4.48226C12.2661 4.43208 12.1364 4.40625 12.0054 4.40625C11.8744 4.40625 11.7448 4.43208 11.6238 4.48226C11.5028 4.53244 11.3929 4.60599 11.3004 4.69869L4.71041 11.2887C4.61771 11.3812 4.54416 11.4911 4.49398 11.6121C4.4438 11.733 4.41797 11.8627 4.41797 11.9937C4.41797 12.1247 4.4438 12.2543 4.49398 12.3753C4.54416 12.4963 4.61771 12.6062 4.71041 12.6987L11.3004 19.2887C11.393 19.3813 11.5029 19.4547 11.6239 19.5048C11.7448 19.5549 11.8745 19.5807 12.0054 19.5807C12.1363 19.5807 12.266 19.5549 12.387 19.5048C12.5079 19.4547 12.6178 19.3813 12.7104 19.2887C12.803 19.1961 12.8764 19.0862 12.9265 18.9652C12.9766 18.8443 13.0024 18.7146 13.0024 18.5837C13.0024 18.4528 12.9766 18.3231 12.9265 18.2022C12.8764 18.0812 12.803 17.9713 12.7104 17.8787L7.83041 12.9987H19.0004C19.5504 12.9987 20.0004 12.5487 20.0004 11.9987C20.0004 11.4487 19.5504 10.9987 19.0004 10.9987Z" fill="black"/>
</svg>
<div className='text-2xl'>Back </div>
</Link>

<div className='ml-[1000px] '>
<EfficiencyHeader/>
</div>
</div>

<div className='ml-[20px] text-[24px] mt-20'>Understand your Baseline and How it affect CCRT </div>
<div className='ml-[20px] mt-20 text-[18px] font-semibold'>
Historical baseline  </div>
<div className='text-gray-500 text-[16px] ml-[20px] mr-[20px] mt-10'>This is the baseline that matters most for your CCRT calculation. It’s calculated using verified historical energy data from your facility, creating a reliable reference point for measuring reductions.<br className='mt-20'></br>
</div>
<div className='text-gray-500 text-[16px] ml-[20px] mr-[20px] mt-10'>

If you add new appliances to your facility, this baseline can be recalculated to reflect the change, which means the Ground Truth Mapping (our way of verifying your actual setup and energy potential) can be updated.</div>

<div className='text-bold text-20 mt-20 ml-[20px]  text-[18px] font-bold'>Improvement baseline</div>

<div className='text-bold text-20 mt-10 ml-[20px]  text-[18px] text-gray-500 '>It shows your current energy usage after implementing improvements. This baseline helps you see how far you've come since your main historical baseline. It's part of how we show progress but it's not used to calculate your CCRT.  <Link to={"/profile"}>
<span className='underline text-[#038B47] '>Ground Truth Mapping</span> </Link></div>


<ImprovementBaselineHistory/>

</div>

    

    </div>


    </>
  )
}

export default EfficiencyBaselineTables
